import React from 'react';
import { Flex, Typography } from 'antd';
import { VAREXE_LOGO_MINIMAL_CDN_URL } from '../../constants/varexeBrand';

const { Text } = Typography;

/**
 * “Powered by” row with Gridbind wordmark (CDN) linking to gridbind.com.
 */
const PoweredByVarexe = ({
  textColor = 'var(--varexe-gray-400)',
  fontSize = 11,
  logoHeight = 18,
}) => (
  <Flex align="center" justify="center" gap={8} wrap="wrap">
    <Text style={{ color: textColor, fontSize, margin: 0 }}>Powered by</Text>
    <a
      href="https://gridbind.com"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        lineHeight: 1,
        color: textColor,
        fontWeight: 600,
        fontSize,
      }}
    >
      <img
        src={VAREXE_LOGO_MINIMAL_CDN_URL}
        alt=""
        height={logoHeight}
        style={{ display: 'block', height: logoHeight, width: 'auto' }}
      />
      <span>Gridbind</span>
    </a>
  </Flex>
);

export default PoweredByVarexe;
